import React from 'react';
import ConversationItem from './ConversationItem';

const ConversationList = ({ conversations, selectedId, onSelect, loading }) => {
    if (loading) {
        return (
            <div className="conv-loading">
                {[1,2,3,4,5].map(i => (
                    <div key={i} className="conv-skeleton">
                        <div className="conv-skeleton-avatar" />
                        <div className="conv-skeleton-lines">
                            <div className="conv-skeleton-line" style={{ width: '60%' }} />
                            <div className="conv-skeleton-line" style={{ width: '80%' }} />
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (!conversations.length) {
        return (
            <div className="conv-empty">
                <div className="conv-empty-icon">📭</div>
                <p>No conversations found</p>
            </div>
        );
    }

    return (
        <div className="conv-list">
            {conversations.map(conv => (
                <ConversationItem
                    key={conv._id}
                    conversation={conv}
                    isSelected={selectedId === conv._id}
                    onClick={() => onSelect(conv)}
                />
            ))}
        </div>
    );
};

export default ConversationList;
